import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../../services/index';

@Component({
  selector: 'app-itemqrcode',
  templateUrl: './itemqrcode.component.html',
  styleUrls: ['./itemqrcode.component.scss'],
  providers:[InventoryService]
})
export class ItemqrcodeComponent implements OnInit {


    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    arritems:any=[];
    arrmjgrp:any=[];
    arrmngrp:any=[];
    itemmodel:any={};
    objqrprint:any={};
  objqrprintbulk:any={};
    tab=1;
    charcnt=0;
  
    status = [
      {
        id: 1,
        name: 'Active'
      },
      {
        id: 2,
        name: 'Inactive'
      }
   ];

   arrqrtypes:any=
   [
   {name:'1UP QRcode 50 X 25',value:'invqritem'},
   {name:'1UP QRcode 50 X 75',value:'invqritem_5075'},
  
 ]
  
    constructor(private iservice: InventoryService,private modalService: NgbModal) { }
  
    openmodal(content) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
    ngOnInit(): void {
      this.getinvmitem();
   
  
    }
  
    qropen(bkid){
      var clcd=localStorage.getItem('clcd');
      var aycd=localStorage.getItem('aycd');
       var url=this.iservice.callurl+"qrcode/invqritem.php?clcd="+clcd+"&aycd="+aycd+"&id="+bkid;
    
       window.open(url,'');
     }
    getinvmitem() {
      this.iservice.getinvqritem()
          .subscribe(
          resultArray => {
              console.log('getlibcategory', resultArray);
             // resultArray.forEach(x => x.status = x.status === 'true');
              this.arritems = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }
    opendialog(content,objdata,cmd) {
      if(cmd=='insert')
      {
        this.itemmodel={};
        this.itemmodel.id=0;
        this.itemmodel.icd='';
        this.itemmodel.inm='';
        this.itemmodel.ides='';
       
        this.itemmodel.oprtype='insert';
        
  
      }
  
      else if(cmd=='update')
      {
        this.itemmodel=objdata;

      
        this.itemmodel.oprtype='update';
        this.getcharatercount(this.itemmodel);
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    getcharatercount(item)
    {

      var icd=item.icd;
      var ln1=0,ln2=0,ln3=0;
      if(item.icd != '')
      {
        ln1=item.icd.length;
      }
      if(item.inm != '')
      {
        ln2=item.inm.length;
      }
      if(item.ides != '')
      {
        ln3=item.ides.length;
      }
var ttllength=ln1+ln2+ln3;
this.charcnt=ttllength;
console.log('count',ttllength);
    }
    SaveDetails()
    {
  console.log('catsave',this.itemmodel);
      this.iservice.saveinvqritem(this.itemmodel)
          .subscribe(
          result => {
              console.log('savelibcategory', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='Success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
                this.getinvmitem();
                //this.getlibcategory();
  
              }
             else
             {
  
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }


    printqrlabels(obj){
      debugger;
        var clcd=localStorage.getItem('clcd');
        var aycd=localStorage.getItem('aycd');
         var url=this.iservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&id="+obj.bkid+"&noc="+obj.nobc;
         window.open(url,'','');
       }
      
       printqrlabelsbulk(obj){
        debugger;
          var clcd=localStorage.getItem('clcd');
          var aycd=localStorage.getItem('aycd');
           var url=this.iservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&pretxt="+obj.pretxt+"&noc="+obj.nobc+"&frm="+obj.rfrm+"&to="+obj.rto+"&tag=bulk"+"&id=0";
           window.open(url,'','');
         }

         openqrdlbulk(content)
{
  //this.objqrprint.bkid=bkid;
  this.objqrprintbulk.nobc=1;
  this.objqrprintbulk.qrdoctype='invqritem';
  this.objqrprintbulk.pretxt='';

  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

openqrdl(content,bkid)
{
  this.objqrprint.bkid=bkid;
  this.objqrprint.nobc=1;
  this.objqrprint.qrdoctype='invqritem';

  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}
  }